import ThankYouStep from "../ThankYouStep/ThankYouStep";

type Props = {
    placeHoldersMap: Record<string, string>,
    isCannaleoPreSelected?: boolean,
    isEPrescriptionOnly?: boolean,
    language?: string,
    page?: string,
    isOrderOnlyPrescription?: boolean,
    isERecipe?: boolean,
    isSelfPickUp?: boolean,
    isRxSelfPickUp?: boolean,
    selfPickupPaymentModel?: string,
    isExpressShipping?: boolean,
    isOtcOnly?: boolean,
    isTestLab?: boolean,
    isVideoConsultation?: boolean,
    isSchengen?: boolean,
    country?: string,
    isPreOrder?: boolean,
    isNextDayDisplayed?: boolean,
}

const ThankyouStepsWidget : React.FC<Props> = ({ placeHoldersMap, isSchengen = false,isCannaleoPreSelected = false, isEPrescriptionOnly = false ,language = 'de', page = 'thankyou', isOrderOnlyPrescription = false, isERecipe = false, isSelfPickUp = false, isRxSelfPickUp = false, selfPickupPaymentModel = 'prescription_and_medication', isExpressShipping = false, isOtcOnly = false, isTestLab = false, isVideoConsultation = false, country, isPreOrder = false, isNextDayDisplayed = false }) => {
    return (

        <div className="thankyou-steps">
            <ThankYouStep placeHoldersMap={placeHoldersMap} isSchengen={isSchengen} isCannaleoPreSelected={isCannaleoPreSelected} isEPrescriptionOnly={isEPrescriptionOnly} language={language} page={page} stepNumber={1} isOtcOnly={isOtcOnly} isTestLab={isTestLab} isVideoConsultation={isVideoConsultation} country={country} />
            {/* OTC-only orders have 2 steps; test-lab orders keep 3 */}
            {(!isOtcOnly || isTestLab) && <ThankYouStep placeHoldersMap={placeHoldersMap} isSchengen={isSchengen} isCannaleoPreSelected={isCannaleoPreSelected} isEPrescriptionOnly={isEPrescriptionOnly} isRxSelfPickUp={isRxSelfPickUp} selfPickupPaymentModel={selfPickupPaymentModel} language={language} page={page} stepNumber={2} isTestLab={isTestLab} isVideoConsultation={isVideoConsultation} country={country} />}
            <ThankYouStep placeHoldersMap={placeHoldersMap} isSchengen={isSchengen} isCannaleoPreSelected={isCannaleoPreSelected} isSelfPickUp={isSelfPickUp} isRxSelfPickUp={isRxSelfPickUp} selfPickupPaymentModel={selfPickupPaymentModel} isEPrescriptionOnly={isEPrescriptionOnly} isExpressShipping={isExpressShipping} language={language} page={page} stepNumber={isOtcOnly && !isTestLab ? 2 : 3} isTestLab={isTestLab} isVideoConsultation={isVideoConsultation} country={country} isPreOrder={isPreOrder} isNextDayDisplayed={isNextDayDisplayed} />

            {page === 'wire' && <ThankYouStep placeHoldersMap={placeHoldersMap} isEPrescriptionOnly={isEPrescriptionOnly} language={language} page={page} stepNumber={4} country={country} />}
        </div>
    );
};

export default ThankyouStepsWidget;
